// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { ITextFieldProps, ITextFieldStyles, TextField } from '@fluentui/react';

export const JoinTeamsMeetingTextField = (props: ITextFieldProps): JSX.Element => (
  <TextField
    label="Meeting url"
    required
    placeholder="http://teams.microsoft.com/join/..."
    styles={meetingUrlInputStyles}
    {...props}
  />
);

const meetingUrlInputStyles: Partial<ITextFieldStyles> = {
  field: {
    minWidth: '25rem',
    '@media only screen and (max-width: 600px)': {
      minWidth: 'unset'
    }
  }
};
